import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import SidePanel from '../components/SidePanel';
import CreateEventModal from '../components/CreateEventModal';

const AdminEventsPage = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const fetchEvents = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/events`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      

      const data = await response.json();

      if (response.ok) {
        setEvents(data);
      } else {
        setError(data.message || 'Failed to fetch events');
        if (response.status === 401) {
          navigate('/login');
        }
      }
    } catch (error) {
      setError('Error fetching events');
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [navigate]);

  const handleCreate = () => {
    setSelectedEvent(null);
    setIsModalOpen(true);
  };

  const handleEdit = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/events/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      fetchEvents();
    } catch (error) {
      setError('Error deleting event');
    }
  };

  const handleSave = async (formData) => {
    const token = localStorage.getItem('token');
    const method = selectedEvent ? 'PUT' : 'POST';
    const url = selectedEvent
      ? `${process.env.REACT_APP_BASE_URL_API}/api/events/${selectedEvent.id}`
      : `${process.env.REACT_APP_BASE_URL_API}/api/events`;

    const body = new FormData();
    body.append('title', formData.title);
    body.append('description', formData.description);
    body.append('date', formData.date);
    body.append('endDate', formData.endDate);
    body.append('location', formData.location);
    if (formData.image) {
      body.append('image', formData.image);
    }

    try {
      await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body,
      });
      fetchEvents();
      setIsModalOpen(false);
    } catch (error) {
      setError('Error saving event');
    }
  };

  return (
    <div className="flex h-screen bg-[#f4f7fa]">
      <SidePanel handleLogout={handleLogout} />
      <div className="flex-1 p-10">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold text-[#364A9A] font-poppins">Events</h1>
          <button onClick={handleCreate} className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins">
            Create New
          </button>
        </div>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">Title</th>
                  <th className="py-2 px-4 border-b">Location</th>
                  <th className="py-2 px-4 border-b">Date</th>
                  <th className="py-2 px-4 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event) => (
                  <tr key={event.id}>
                    <td className="py-2 px-4 border-b">{event.title}</td>
                    <td className="py-2 px-4 border-b">{event.location}</td>
                    <td className="py-2 px-4 border-b">{new Date(event.date).toLocaleDateString()}</td>
                    <td className="py-2 px-4 border-b">
                      <button onClick={() => handleEdit(event)} className="bg-blue-500 text-white font-bold py-1 px-2 rounded-lg mr-2">
                        Edit
                      </button>
                      <button onClick={() => handleDelete(event.id)} className="bg-red-500 text-white font-bold py-1 px-2 rounded-lg">
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <CreateEventModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} event={selectedEvent} />
    </div>
  );
};

export default AdminEventsPage;
